import { render, staticRenderFns } from "./DialogListEmergencyContacts.vue?vue&type=template&id=7c4ba43e"
import script from "./DialogListEmergencyContacts.vue?vue&type=script&lang=js"
export * from "./DialogListEmergencyContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports